/**
 * Ключ идемпотентности НА значение (вариант, id кадра…), а не один общий на всю панель/компонент.
 *
 * Находка финального ревью (панель «Новый видео-ролик из кадра», `ProjectsPage.tsx`): один общий ключ
 * в `useRef` крутился только по успеху запроса, а сервер (`videoscenario._frame_project_by_key`) ищет
 * проект ТОЛЬКО по ключу, вариант не сверяет. Обрыв связи после того, как POST уже создал проект,
 * оставлял общий ключ прежним — следующий выбор ДРУГОЙ картинки получал в ответ проект по предыдущей.
 *
 * `keyedKey` заводит запись в карте при первом обращении к значению и держит её, пока вызывающая
 * сторона не снимет успехом (`map.delete(id)`) — повтор по тому же значению (в т. ч. после 409 `BUSY`)
 * уходит с прежним ключом, а другое значение получает свой.
 *
 * Без импортов из `@/…`: модуль проверяется `node --test` как есть (как `lib/frameVideo.ts`).
 */
export function keyedKey<K>(map: Map<K, string>, id: K): string {
  let key = map.get(id);
  if (!key) {
    key = typeof crypto.randomUUID === "function" ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    map.set(id, key);
  }
  return key;
}
